import {
  Box,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  Radio,
  Stack,
  TextArea,
  TextField,
  Typography,
  styled,
} from '@nextiva/next-ui-components';
import React from 'react';

export const StyledHeader = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.black};
  margin: 0px 0 16px 0;
`;

export const StyledLabel = styled(Typography)`
  text-transform: none;
`;

export const StyledSubtitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.blueGrey[900]};
  font-weight: 800;
  text-transform: none;
`;

export const StyledIcon = styled(Icon)`
  font-size: 12px;
`;

export const StyledLinkBox = styled(Box)`
  & a {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const StyledTextArea = styled(TextArea)`
  .MuiFormHelperText-root span:nth-child(2) {
    min-width: 80px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }
`;

export const BlueMessage = styled(Typography)`
  background-color: ${({ theme }) => theme.palette.blue[50]};
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 3px 8px;
  border-radius: 4px;
  position: relative;
  right: 25px;
`;

export const UrlTextField = styled(TextField)`
  width: 330px;
  margin-right: 32px;
  p.MuiFormHelperText-root {
    margin: 0px;
  }
`;

export const Header = (props) => {
  return (
    <Grid item xs={12}>
      <StyledHeader variant="h6" {...props} />
      <Divider />
    </Grid>
  );
};

export const RadioLabel = ({ label, value }) => {
  return (
    <FormControlLabel
      label={
        <Box mr="32px">
          <Typography variant="body2">{label}</Typography>
        </Box>
      }
      control={<Radio />}
      value={value}
    />
  );
};

export const VisuallyHiddenInput = styled('input')({
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const UploadGrid = styled(Grid)`
  width: 100%;
  min-height: 72px;
  border: 1px solid #dedfe4;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.grey[50]};
  margin-top: 8px;
  padding: 16px 32px;
`;

export const UploadedFile = styled(Stack)`
  width: 158px;
  height: 56px;
  border: 1px solid #dedfe4;
  border-radius: 8px;
  background-color: white;
  padding: 8px;
  box-shadow: 0px 0px 8px 0px #22264829;
`;
